import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=3cd5dab2&scoped=true&"
import script from "./ArticleList.vue?vue&type=script&lang=js&"
export * from "./ArticleList.vue?vue&type=script&lang=js&"
import style0 from "./ArticleList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ArticleList.vue?vue&type=style&index=1&id=3cd5dab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5dab2",
  null
  
)

export default component.exports